import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Pagination from "react-js-pagination";

function Board2() {
  const [data, setData] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const offset = (page - 1) * limit;
  const handlePageChange = (page) => {
    setPage(page);
  };

  useEffect(() => {
    axios.get("/api/board/list").then((response) => {
      try {
        setData(response.data);
      } catch (error) {
        console.error(error);
      }
    });
  }, []);

  return (
    <div>
      <header class="pb-3 mb-4 mt-3 border-bottom">
        <a
          href="/"
          class="d-flex align-items-center text-dark text-decoration-none"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="32"
            class="me-2"
            viewBox="0 0 118 94"
            role="img"
          >
            <title>Bootstrap</title>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M24.509 0c-6.733 0-11.715 5.893-11.492 12.284.214 6.14-.064 14.092-2.066 20.577C8.943 39.365 5.547 43.485 0 44.014v5.972c5.547.529 8.943 4.649 10.951 11.153 2.002 6.485 2.28 14.437 2.066 20.577C12.794 88.106 17.776 94 24.51 94H93.5c6.733 0 11.714-5.893 11.491-12.284-.214-6.14.064-14.092 2.066-20.577 2.009-6.504 5.396-10.624 10.943-11.153v-5.972c-5.547-.529-8.934-4.649-10.943-11.153-2.002-6.484-2.28-14.437-2.066-20.577C105.214 5.894 100.233 0 93.5 0H24.508zM80 57.863C80 66.663 73.436 72 62.543 72H44a2 2 0 01-2-2V24a2 2 0 012-2h18.437c9.083 0 15.044 4.92 15.044 12.474 0 5.302-4.01 10.049-9.119 10.88v.277C75.317 46.394 80 51.21 80 57.863zM60.521 28.34H49.948v14.934h8.905c6.884 0 10.68-2.772 10.68-7.727 0-4.643-3.264-7.207-9.012-7.207zM49.948 49.2v16.458H60.91c7.167 0 10.964-2.876 10.964-8.281 0-5.406-3.903-8.178-11.425-8.178H49.948z"
              fill="currentColor"
            ></path>
          </svg>
          <span class="fs-4">게시판 예제</span>
        </a>
      </header>
      <div>
        이 페이지는 DB와 연결TEST 페이지 이며 DB data의 총 개수는 :{data.length}
        개 입니다.
      </div>
      <br />
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="제목을 입력해주세요."
        />
        <button type="submit" class="btn btn-secondary">
          검색
        </button>
      </div>
      <br />
      <div>
        <div>
          페이지 당 표시할 게시물 수:&nbsp;
          <select
            type="number"
            value={limit}
            onChange={({ target: { value } }) => {
              setLimit(Number(value));
              setPage(1);
            }}
          >
            <option value="1">1</option>
            <option value="10">10</option>
            <option value="12">12</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </div>

      <ul>
        <li>
          <ul>
            <li>
              <label class="checkbox-inline">
                <input type="checkbox" id="allCheckBox" class="chk" />
              </label>
            </li>
            <li>NO.</li>
            <li>제목</li>
            <li>작성자</li>
            <li>조회수</li>
            <li>작성일</li>
          </ul>
        </li>
        {data.slice(offset, offset + limit).map((data) => (
          <li key={data.idx}>
            <Link to={`/board/${data.idx}`}>
              <ul>
                <li>
                  <label class="checkbox-inline">
                    <input type="checkbox" id="allCheckBox" class="chk" />
                  </label>
                </li>
                <li>{data.idx}</li>
                <li>{data.title}</li>
                <li>{data.writer}</li>
                <li>{data.view_count}</li>
                <li>{data.createdAt.substr(0, 10)}</li>
              </ul>
            </Link>
          </li>
        ))}
      </ul>
      <div>
        <hr />
        <div>
          <Pagination
            totalItemsCount={data.length}
            itemsCountPerPage={limit}
            activePage={page}
            pageRangeDisplayed={5}
            onChange={handlePageChange}
          />
        </div>
        <Link to={`/board/write`}>
          <button class="btn btn-primary justify-content-end">글쓰기</button>
        </Link>
      </div>
    </div>
  );
}
export default Board2;
